module.exports = __webpack_public_path__ + "static/media/allCommand.9b4803e5.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/Home/allCommand.png
 ** module id = 628
 ** module chunks = 0
 **/